export const exportToCSV = (data, filename) => {
  if (!data) return;

  // Se os dados vierem separados em abas (como as vendas), juntamos tudo para o CSV, que não tem abas.
  let flatData = data;
  if (!Array.isArray(data)) {
    flatData = [];
    Object.values(data).forEach(sheetRows => {
      if (Array.isArray(sheetRows)) flatData.push(...sheetRows);
    });
  }

  if (flatData.length === 0) return;

  const headers = Object.keys(flatData[0]);
  const csvContent = [
    headers.join(','),
    ...flatData.map(row => headers.map(header => {
      const value = row[header];
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
};

export const exportToExcel = (data, filename) => {
  if (!data) return;

  let sheetsData = {};
  
  // Se for uma lista simples (como Produtos e Clientes), cria uma aba padrão "Dados"
  if (Array.isArray(data)) {
    if (data.length === 0) return;
    sheetsData['Dados'] = data;
  } else {
    // Se já vier estruturado em abas (como as Vendas por Mês)
    if (Object.keys(data).length === 0) return;
    sheetsData = data;
  }

  // Proteção contra caracteres que quebram a planilha
  const escapeXML = (str) => {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };

  // Cabeçalho nativo da Microsoft (XML Spreadsheet)
  let xml = `<?xml version="1.0"?>
  <?mso-application progid="Excel.Sheet"?>
  <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
    xmlns:o="urn:schemas-microsoft-com:office:office"
    xmlns:x="urn:schemas-microsoft-com:office:excel"
    xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
    xmlns:html="http://www.w3.org/TR/REC-html40">`;

  // Motor criador de abas e colunas
  for (const sheetName in sheetsData) {
    const rows = sheetsData[sheetName];
    if (!rows || rows.length === 0) continue;

    const headers = Object.keys(rows[0]);
    
    xml += `<Worksheet ss:Name="${escapeXML(sheetName)}">`;
    xml += `<Table>`;
    
    xml += `<Row>`;
    headers.forEach(header => {
      xml += `<Cell><Data ss:Type="String">${escapeXML(header)}</Data></Cell>`;
    });
    xml += `</Row>`;

    rows.forEach(row => {
      xml += `<Row>`;
      headers.forEach(header => {
        xml += `<Cell><Data ss:Type="String">${escapeXML(row[header])}</Data></Cell>`;
      });
      xml += `</Row>`;
    });

    xml += `</Table>`;
    xml += `</Worksheet>`;
  }

  xml += `</Workbook>`;

  const blob = new Blob([xml], { type: 'application/vnd.ms-excel' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}_${new Date().toISOString().split('T')[0]}.xls`;
  link.click();
};
